<template>
  <div
    v-auto-focus="focusCtrl"
    :data-current="currentIndex"
    :data-action="actionType"
    class="page-container"
  >
    <question class="question" index="03">{{
      $t("survey.advice.improvement")
    }}</question>
    <input-area
      class="advice-input"
      :maxlength="1000"
      :showTipLength="940"
      :textContent.sync="improvement"
      data-index="0"
    ></input-area>
    <question class="question" index="04">{{
      $t("survey.advice.contact")
    }}</question>
    <input-area
      class="advice-input"
      :placeholder="$t('survey.contactWay')"
      :textContent.sync="contact"
      data-index="1"
    ></input-area>
    <next-button @click="onDone">{{ $t("survey.done") }}</next-button>
  </div>
</template>

<script>
import Question from '../../components/Question'
import InputArea from '../../components/InputArea'
import NextButton from '../../components/NextButton'
import utils from '../../utils'
import mixin from './mixin'


export default {
  name: 'Advice',

  components: { NextButton, InputArea, Question },

  mixins: [mixin],

  data() {
    return {
      improvement: '',
      contact: '',
      hideBtn: false,
      focusCtrl: 0,  // 自动聚焦控制,变动时,执行自动聚焦指令
      currentIndex: 0, // 当前聚焦元素的索引
      actionType: 'next', // 自动聚焦的行为类型
    }
  },

  mounted() {
    this.checkScore()
  },

  destroyed() {
    const nextPath = this.$route.path
    if (nextPath.includes('reason')) {
      utils.native.showToast(this.$t('survey.toastTips'))
      utils.native.closeWindow()
    }
  },

  methods: {
    //点击完成
    onDone() {
      this.$s.setAdvice({
        improvement: this.improvement,
        contact: this.contact,
      })
      this.reportData()
      utils.native.showToast(this.$t('survey.toastTips'))
      utils.native.closeWindow()
    },
    //数据上报
    reportData() {
      // utils.native.reportEvent(
      //   {
      //     event_id: "advance_element_action",
      //     element_id: "nps_survey",
      //     sub_element_id: "nps_otherwise",
      //     content_id: this.improvement,
      //     action: "next",
      //     page: utils.store.getQueryVariable('page')
      //   })
      gio('track', 'advance_element_action', {
        "element_id": "nps_survey",
        "sub_element_id": "nps_otherwise",
        "content_id": this.improvement,
        "action": "next",
        "page": utils.store.getQueryVariable('page')
      });
      // utils.native.reportEvent(
      //   {
      //     event_id: "advance_element_action",
      //     element_id: "nps_survey",
      //     sub_element_id: "nps_contact",
      //     content_id: this.contact,
      //     action: "next",
      //     page: utils.store.getQueryVariable('page')
      //   })
      gio('track', 'advance_element_action', {
        "element_id": "nps_survey",
        "sub_element_id": "nps_contact",
        "content_id": this.contact,
        "action": "next",
        "page": utils.store.getQueryVariable('page')
      });
    },
  }
}
</script>

<style lang="stylus" scoped>
.question {
  margin: 60px auto 28px;
}

.advice-input {
  margin: 0 38px;

  &:focus {
    background: red;
  }
}
</style>
